$(document).ready(function () {
    var $flightCardJourney = $('.flight-card--journey');
    if ($flightCardJourney.length > 0) {
        //toggle of button on flight information
        var currentHeight = $flightCardJourney.outerHeight();
        if (currentHeight < 320) {
            $('.flight-card--journey__expand').hide();
            $('.flight-card--save ').css('box-shadow', '0 -3px 3px 0 rgba(0,0,0,.2)');
        }
        else {
            $flightCardJourney.animate({ height: '320' });
        }
        $flightCardJourney.addClass('closed');

        $('#expand').on('click', function () {
            if ($('.flight-card--journey').hasClass('closed')) {
                $('.flight-card--journey').animate({ height: currentHeight });
                $('.flight-card--save ').css('box-shadow', '0 -3px 3px 0 rgba(0,0,0,.2)');
                $('.flight-card--journey').removeClass('closed');
                $('.flight-card--journey__expand').fadeIn('slow').html("<i class='fa fa-chevron-up'</i>");
            }
            else {
                $('.flight-card--journey').animate({ height: '320' });
                $('.flight-card--journey').addClass('closed');
                $('.flight-card--journey__expand').fadeIn('slow').html("<i class='fa fa-chevron-down'</i>");
                $('.flight-card--save ').css('box-shadow', '0 -10px 3px 0 rgba(0,0,0,.2)');
            }
        });

        if ($.cookie('userSavedFlight') === location.search.replace('?fltnmbr=', '')) {
            $('.toggle').hide();
            $('.saveflight').html("Saved <i class='fa fa-check'></i> ");
        }

        if ($.cookie('userSavedFlight') !== location.search.replace('?fltnmbr=', '')
            && typeof $.cookie('userSavedFlight') !== 'undefined') {
            $('.saveflight').html("Replace Flight <i class='fa fa-angle-right'></i>");
        }

        $('.lower-saveflight-button').on('click', function () {
            ShowFlightSavedMessage();
        });

        $('.saveflight').on('click', function () {
            var $headerFlight = $('.header-flight');
            $headerFlight.hide();

            if (window.location.search) {
                var flightNumber;
                var queryString = window.location.search.substring(1);
                var queryParams = queryString.split('&');
                for (var i = 0; i < queryParams.length; i++) {
                    var queryParam = queryParams[i].split('=');
                    if (decodeURIComponent(queryParam[0]) == 'fltnmbr') {
                        flightNumber = decodeURIComponent(queryParam[1]);
                    }
                }

                if (flightNumber) {
                    if (typeof $.cookie('userSavedFlight') !== 'undefined') {
                        $.removeCookie('userSavedFlight');
                    }

                    $.cookie('userSavedFlight', flightNumber, { path: '/;SameSite=Lax', secure: true });

                    var template = $('#header-flight-info-template').html();
                    Mustache.parse(template);

                    var flightInfo = {
                        'flightNumber': $.cookie('userSavedFlight'),
                        'airlineLogo': $('#hdnImage').val(),
                        'fromTo': $('#hdnToOrFrom').val(),
                        'airport': $('#hdnOrgDest').val(),
                        'departingArriving': $('#hdnToOrFrom').val() === 'To' ? 'Depart' : 'Arrive',
                        'scheduledTime': $('#hdnTime').val(),
                        'status': $('#hdnFlightStatus').val()
                    };

                    var rendered = Mustache.render(template, flightInfo);
                    $('#header-flight-info').html(rendered);
                    setTimeout(function () { $headerFlight.show(); }, 0);

                    $('.saveflight').html('Saved <i class="fa fa-check"></i>');
                    $('.toggle').fadeOut();
                }
            }
        });
    }
});